import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MailFile } from 'src/app/shared/models/mails/mail-file';
import * as async from 'async';
import { ToastrService } from 'ngx-toastr';
import { Cols } from 'src/app/shared/models/cols';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { LiveCircuitsDTO } from 'src/app/shared/interfaces/pastell/live-circuit-dto.interface';
import { FilesService } from 'src/app/shared/services/files.service';
import { ConnectorsService } from 'src/app/shared/services/connectors.service';

@Component({
  selector: 'app-modal-assign-pastell-circuit',
  templateUrl: './modal-assign-pastell-circuit.component.html',
  styleUrls: ['./modal-assign-pastell-circuit.component.scss'],
})
export class ModalAssignPastellCircuitComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    pastellUserId: new FormControl(null, Validators.required),
    entityId: new FormControl(null, Validators.required),
    connecteurId: new FormControl(null, Validators.required),
    circuitType: new FormControl(null, Validators.required),
    circuitSousType: new FormControl(null, Validators.required),
    dateLimite: new FormControl(null),
    attachmentIds: new FormControl(null),
  });

  public mailId: number;
  public chosenFile: MailFile;
  public listOfFilesFiltered: MailFile[] = []; // List of the files of the current mail, filtered by : has extension .pdf && ! pastellCircuitId && id !== this.chosenFile
  public listOfCircuits: { label: string; value: { entityId: string; sousType: string } }[] = [];
  private allLiveCircuits: LiveCircuitsDTO[] = [];
  public columnsCircuits: Cols[] = [{ field: 'description', header: 'courrierFiche.column.description' }];
  public selectedTableLines: MailFile[] = [];

  public titleButtons: IButton[] = [
    {
      text: 'cancel',
      styleClass: 'red',
      click: () => {
        this.close();
      },
    },
    {
      text: 'confirm',
      styleClass: 'green',
      click: () => {
        this.submitDatas();
      },
    },
  ];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public toastr: ToastrService,
    public translater: TranslateService,
    private filesService: FilesService,
    private connectorsService: ConnectorsService
  ) {}

  ngOnInit(): void {
    this.columnsCircuits = this.columnsCircuits.map((col) => {
      col.header = this.translater.translate(col.header);
      return col;
    });
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
    if (this.config?.data) {
      this.chosenFile = this.config.data.file;
      this.listOfFilesFiltered = this.config.data.listOfFiles.filter(
        (file) => file.extension === 'pdf' && !file.pastellCircuitId && file.id !== this.chosenFile.id
      );
      this.mailId = this.config.data.mailId;

      this.connectorsService.getLiveCircuit().subscribe({
        next: (listOfLiveCircuits) => {
          this.allLiveCircuits = listOfLiveCircuits;

          listOfLiveCircuits.forEach((circuit) => {
            circuit.iParapheurSousTypes.forEach((sousType) => {
              this.listOfCircuits.push({
                label: circuit.entity + '/' + sousType,
                value: { entityId: circuit.entityId, sousType: sousType },
              });
            });
          });
        },
        error: (error) => {
          this.listOfCircuits = [];
          console.error(error);
          this.toastr.error('Une erreur est survenue lors de la récupération des circuits');
        },
      });
    }
  }

  changeCircuit(event: { originalEvent: PointerEvent; value: { entityId: string; sousType: string } }): void {
    if (event?.value) {
      const foundCircuit = this.allLiveCircuits.find((circuit) => circuit.entityId == event.value.entityId);
      this.form.patchValue({
        pastellUserId: foundCircuit.pastellUserId,
        entityId: foundCircuit.entityId,
        connecteurId: foundCircuit.connecteur,
        circuitType: foundCircuit.iParapheurType,
        circuitSousType: event.value.sousType,
      });
    }
  }

  onRowSelection(event): void {
    this.selectedTableLines = event;
  }

  submitDatas(): void {
    if (this.form.valid) {
      if (this.selectedTableLines?.length > 0) {
        this.form.patchValue({
          attachmentIds: this.selectedTableLines.map((file) => file.id),
        });
      } else {
        this.form.patchValue({
          attachmentIds: [],
        });
      }
      this.filesService.assignCircuitPastell(this.mailId, this.chosenFile.id, this.form.value).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('courrierFiche.successCircuitAssociated'));
          this.ref.close({ reload: true });
        },
      });
    } else {
      this.toastr.error(this.translater.translate('courrierFiche.errorNeedToChooseACircuit'));
    }
  }

  close(): void {
    this.ref.close();
  }
}
